/*
 * lunna-cart-bump.js — o botão "Add" do adicional na gaveta do carrinho.
 *
 * Delegação no document, e não listener no botão: a gaveta troca o próprio
 * HTML inteiro a cada mudança no carrinho (renderContents), então um listener
 * preso ao botão morreria na primeira atualização.
 *
 * Adiciona pela mesma rota do formulário de produto (/cart/add pedindo as
 * seções da gaveta de volta) e entrega a resposta para a própria gaveta
 * redesenhar. Nenhuma lógica de carrinho paralela: se o Dawn mudar a gaveta,
 * este arquivo continua certo.
 *
 * Modo prévia: ?lunna_bump_preview=1 grava a chave neste navegador e a classe
 * no <html> revela o adicional marcado como prévia (cart_bump_live vazio ou
 * false). ?lunna_bump_preview=0 apaga a chave.
 */
(function () {
  var PREVIEW_KEY = 'lunnaBumpPreview';

  function applyPreviewFlag() {
    try {
      var param = new URLSearchParams(window.location.search).get('lunna_bump_preview');
      if (param === '1') window.localStorage.setItem(PREVIEW_KEY, '1');
      if (param === '0') window.localStorage.removeItem(PREVIEW_KEY);
      if (window.localStorage.getItem(PREVIEW_KEY) === '1') {
        document.documentElement.classList.add('lunna-bump-preview');
      }
    } catch (error) {
      // Sem storage (aba privada, webview restrito): a prévia só não aparece.
    }
  }

  function showError(container, message) {
    var slot = container && container.querySelector('.lunna-cart-bump__error');
    if (!slot) return;
    slot.textContent = message;
    slot.hidden = false;
  }

  // O texto mora num <span> para o ícone de "+" sobreviver ao "Adding…".
  function labelOf(button) {
    return (button.querySelector && button.querySelector('[data-lunna-cart-bump-label]')) || button;
  }

  function add(button) {
    if (button.getAttribute('aria-disabled') === 'true') return;

    var variantId = button.getAttribute('data-variant-id');
    var container = button.closest('[data-lunna-cart-bump]');
    var cart = document.querySelector('cart-drawer');
    if (!variantId || typeof fetchConfig !== 'function') return;

    var labelSlot = labelOf(button);
    var label = labelSlot.textContent;
    button.setAttribute('aria-disabled', 'true');
    labelSlot.textContent = 'Adding…';

    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.append(
        'sections',
        cart.getSectionsToRender().map(function (section) {
          return section.id;
        })
      );
      body.append('sections_url', window.location.pathname);
    }
    config.body = body;

    fetch(window.routes.cart_add_url, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          throw new Error(response.description || response.message || 'This item could not be added.');
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'lunna-cart-bump',
            productVariantId: variantId,
            cartData: response,
          });
        }

        if (cart && typeof cart.renderContents === 'function' && response.sections) {
          cart.renderContents(response);
        } else {
          window.location = window.routes.cart_url;
        }
      })
      .catch(function (error) {
        button.removeAttribute('aria-disabled');
        labelSlot.textContent = label;
        showError(container, error && error.message ? error.message : 'This item could not be added.');
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest && event.target.closest('[data-lunna-cart-bump-add]');
    if (!button) return;
    event.preventDefault();
    add(button);
  });

  applyPreviewFlag();
})();
